"use client";
import React from "react";
import { FinishEnum, NONFOIL_FINISH } from "modules/cards/model/card";
import { Select, SelectOption } from "modules/common/components/ui/Select";
import { useSwapFormState } from "modules/swap-calculator/stores/useSwapCalculatorStore";
import { finishOptions } from "modules/cards/utils/finish";

function AutocompleteFinish() {
  // Optimal Zustand selector - only re-renders when form state changes
  const { selectedCard, finish, setFinish } = useSwapFormState();

  const cardIsSelected = selectedCard && selectedCard.id;
  const isDisabled =
    !selectedCard?.id || (selectedCard && selectedCard.finishes.length === 1);

  const handleFinishChange = (value: string | number) => {
    setFinish(value as FinishEnum);
  };

  const options: SelectOption[] = cardIsSelected
    ? finishOptions(selectedCard.finishes)
    : finishOptions([NONFOIL_FINISH]);

  return (
    <div className="form-control w-full">
      <Select
        name={"finish"}
        layout={"horizontal"}
        label={"Finish"}
        options={options}
        value={finish}
        onChange={handleFinishChange}
        disabled={isDisabled}
        size="sm"
        className="md:select-md w-full"
        placeholder="Finish"
      />
    </div>
  );
}

export default AutocompleteFinish;
